module.exports = {
      id: "share-facebook-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#share-facebook",
      toString: function () {
        return this.url;
      }
    }